<div class="modal-body oauth-client-credentials-modal">
  <p class="centermodal__title">{{ 'settings.oauthClients.credentialsTitle' | translate }}</p>
  <p class="oauth-client-credentials-modal__description">{{ 'settings.oauthClients.credentialsDescription' | translate }}</p>

  <div class="oauth-client-credentials-modal__fields">
    <div class="oauth-client-credentials-modal__field">
      <span>{{ 'settings.oauthClients.clientId' | translate }}</span>
      <button type="button" class="oauth-client-credentials-modal__copy" (click)="copyToClipboard(client?.id)">
        {{ client?.id }}
        <i class="fa-regular fa-copy"></i>
      </button>
    </div>

    <div class="oauth-client-credentials-modal__field">
      <span>{{ 'settings.oauthClients.clientSecret' | translate }}</span>
      <button type="button" class="oauth-client-credentials-modal__copy" (click)="copyToClipboard(client?.client_secret)">
        {{ client?.client_secret }}
        <i class="fa-regular fa-copy"></i>
      </button>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="modal.close()">
      {{ 'button.close' | translate }}
    </button>
  </div>
</div>
